module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Добавить")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.createNew
          }
        }, [_vm._v("Новый")])]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_vm._l((_vm.strategy.getSteps()), function(step) {
    return [_c('v-step-generator', _vm._b({
      tag: "component",
      model: {
        value: (step.model),
        callback: function($$v) {
          _vm.$set(step, "model", $$v)
        },
        expression: "step.model"
      }
    }, 'component', step.props, false))]
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dd2cf5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/StrategyForm.vue
// module id = 841
// module chunks = 1